import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { StackScreen } from '@life-line-lab/components-react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useRecoilState } from 'recoil';
import { accountAtom } from 'Recoil/account.atom';
import { isNil } from 'lodash';
import AccountCreateForm from 'Components/account/account-create/account-create-form';

const AccountCreate = () => {

    const history = useHistory();
    const { t } = useTranslation();
    const [accountState, setAccountState] = useRecoilState<any>(accountAtom);
    const [error, setError] = useState<any>();

    const handleCloseStackScreen = () => {
        // history.push('/accounts');
        history.goBack();
    }

    const handleSubmit = async (input: any) => {
        setAccountState({ ...accountState, status: { create: 'loading' } });
        const responseData = await createUser(input);

        if (!isNil(responseData.error)) {
            setAccountState({ ...accountState, status: { create: 'error' } });
            setError(responseData?.error);
        }
        else {
            setAccountState({ ...accountState, status: { create: 'success' } });
            setAccountState({ ...accountState, data: responseData });
            handleCloseStackScreen();
        }
    }

    return (
        <div className="account-create-page">
            <Helmet>
                <title>{t('pageTitle.newAccount')}</title>
            </Helmet>

            <StackScreen
                title={t('title.newAccount')}
                isOpen={true}
                renderHeader={<div></div>}
                onClose={handleCloseStackScreen}
            >
                {/* <UserForm
                    onCancel={() => { }}
                    onSubmit={handleSubmit}
                /> */}
                <AccountCreateForm onSubmit={handleSubmit} />
            </StackScreen>
        </div>
    )
}

export default AccountCreate
